// extracted by mini-css-extract-plugin
module.exports = {"unassignedInquiriesContainer":"unassignedInquiries_unassignedInquiriesContainer___Fd9B","separator":"unassignedInquiries_separator__sI0Ld"};